




















import { Component, Prop, Vue } from 'vue-property-decorator'
import Search from '@/app/ui/components/Search/index'

@Component({
  components: {
    search: Search,
  },
})
export default class extends Vue {
  @Prop({}) public funcSearch: any | undefined
  @Prop({}) public textSearch: any | undefined
}
